import reduceAllBulkAssemblies from 'molbio/bulk-assembly/reduceAllBulkAssemblies';
import {AllBulkAssembliesState} from 'molbio/bulk-assembly/reduceAllBulkAssemblies';
import reduceFeaturePanelUI, {AllFeaturePanelUIState} from 'toolbar/feature-panel/reduceFeaturePanelUI';
import combineBenchlingReducers from 'util/combineBenchlingReducers';

import reduceNucleotidesUI, {AllNucleotidesUIState} from './monomers/reduceNucleotidesUI';

export interface MolbioUIState {
  bulkAssemblies: AllBulkAssembliesState;
  nucleotidesUI: AllNucleotidesUIState;
  featurePanelUI: AllFeaturePanelUIState;
}

export default combineBenchlingReducers({
  bulkAssemblies: reduceAllBulkAssemblies,
  nucleotidesUI: reduceNucleotidesUI,
  featurePanelUI: reduceFeaturePanelUI,
});
